import {BaseAnalyticsEvent} from "../../../../infrastructure/models/analytics/base-analytics-event";

export class CompetitorPlayerStatsModuleShotMapShotClickEventModel extends BaseAnalyticsEvent {
  athleteId: Number;
  gameId: Number;
  status: Number;
  outcome: Number;

  constructor(params) {
    super('shot-click', 'shot-map-popup', 'live-stats');

    this.athleteId = params.athleteId;
    this.gameId = params.gameId;
    this.status = params.status;
    this.outcome = params.outcome;
  }

  get properties() {
    const properties = super.properties;

    properties.athleteId = this.athleteId;
    properties.gameId = this.gameId;
    properties.status = this.status;
    properties.outcome = this.outcome;

    return properties;
  }
}
